import React from 'react';
import { Skeleton, Box, Card, CardContent } from '@mui/material';

export const DashboardCardSkeleton: React.FC = () => (
  <Card sx={{ minWidth: 200, boxShadow: 2 }}>
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Skeleton variant="circular" width={32} height={32} sx={{ mr: 1 }} />
        <Skeleton variant="text" width={80} height={32} />
      </Box>
      <Skeleton variant="text" width={120} />
    </CardContent>
  </Card>
);

const TableRowSkeleton: React.FC = () => (
  <Box sx={{ display: 'flex', gap: 2, p: 2 }}>
    <Skeleton variant="text" width={150} />
    <Skeleton variant="text" width={100} />
    <Skeleton variant="text" width={120} />
    <Skeleton variant="text" width={80} />
  </Box>
);

export const DataGridSkeleton: React.FC = () => (
  <Box sx={{ height: 600, width: '100%' }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
      <Skeleton variant="text" width={200} height={40} />
      <Skeleton variant="rectangular" width={120} height={40} />
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {Array.from({ length: 10 }).map((_, index) => (
        <TableRowSkeleton key={index} />
      ))}
    </Box>
  </Box>
); 